import type { SVGProps } from "react";
export interface BbqGrillIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function BbqGrillIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: BbqGrillIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M10.875 22v-.875h-3.18l-.689 1.378L6 22l-1.006-.503 3.275-6.55a1.125 1.125 0 0 1 2.013 1.006l-1.46 2.922h2.053v-2.876a1.125 1.125 0 0 1 2.25 0v2.876h2.054l-1.46-2.922 1.006-.503 1.006-.504 3.275 6.551a1.125 1.125 0 0 1-2.012 1.006l-.689-1.378h-3.18V22a1.125 1.125 0 0 1-2.25 0m-3.869.503a1.125 1.125 0 0 1-2.012-1.006zm7.216-8.06a1.125 1.125 0 0 1 1.509.503l-2.013 1.007a1.125 1.125 0 0 1 .504-1.51M7.604.948a1.125 1.125 0 0 1 .809 2.099l.257.55c.612 1.31-.23 2.564-1.274 2.957L7 5.5l-.361-.956.757 2.009a1.125 1.125 0 0 1-.81-2.1l-.256-.549c-.612-1.31.23-2.564 1.274-2.957Zm4.5 0a1.125 1.125 0 0 1 .809 2.099l.257.55.099.245c.407 1.219-.394 2.343-1.373 2.712L11.5 5.5l-.361-.956.757 2.009a1.125 1.125 0 0 1-.81-2.1l-.256-.549c-.612-1.31.23-2.564 1.274-2.957Zm4.5 0a1.125 1.125 0 0 1 .809 2.099l.257.55.099.245c.407 1.219-.394 2.343-1.373 2.712L16 5.5l-.361-.956.757 2.009a1.125 1.125 0 0 1-.81-2.1l-.256-.549c-.612-1.31.23-2.564 1.274-2.957Z"
      />
      <path
        fill={color}
        d="M19 7.875c.622 0 1.125.504 1.125 1.125q-.002.188-.011.375H21l.116.006A1.125 1.125 0 0 1 21 11.625h-1.311a8.13 8.13 0 0 1-7.689 5.5 8.13 8.13 0 0 1-7.689-5.5H3a1.125 1.125 0 0 1 0-2.25h.886q-.01-.187-.011-.375l.005-.116A1.126 1.126 0 0 1 5 7.875zM6.26 10.26l.128.488a5.879 5.879 0 0 0 11.351-.488l.027-.135H6.234l.027.135Z"
      />
    </svg>
  );
}
